var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vertical-menu"},_vm._l((_vm.$global.chapters[_vm.$route.meta.category]),function(chapter,key){return _c('router-link',{key:key,attrs:{"lal":key,"to":key}},[_vm._v("\n        "+_vm._s(chapter)+"\n    ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }